<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-2">
      <div>
        <div class="section-title">{{ $tc("weekwiseContract", 2) }}</div>
      </div>
      <div class="d-flex align-items-center">
        <div>
          <b-button
            v-if="$can('create', 'Weekwise Contract')"
            variant="default"
            to="add-weekwise-contract"
            class="btn-blue"
            >{{ $tc("add") }}</b-button
          >
        </div>

        <div class="d-flex align-items-center">
          <!-- <FilterByStatusDropdown /> -->
          <div class="mx-2">
            <b-dropdown id="listview" variant="outline-blue">
              <template v-slot:button-content>
                <!-- Viewing&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp; -->
                <strong>{{ viewingRange }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <button
            class="btnj btn-gridView mr-3"
            v-if="GridViewFlag"
            :class="gridView ? 'active' : ''"
            v-on:click="viewType('gridView')"
          ></button>
          <button
            class="btnj btn-listView"
            v-if="GridViewFlag"
            :class="listView ? 'active' : ''"
            v-on:click="viewType('listView')"
          ></button>
        </div>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(contract, contractKey) in contracts_by_weekwise"
        :key="contractKey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ contract.contract_weekwise_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Weekwise Contract')"
                  @click="
                    goToRoute('/distributor/edit-weekwise-contract', contract)
                  "
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute('/distributor/view-weekwise-contract', contract)
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <StatusDot
                :status="
                  contract.contracts_by_weekwise_is_active == 'Y'
                    ? 'active'
                    : 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView" style="margin-bottom: 25px">
      <thead>
        <tr>
          <th class="text-left" style="width: 100px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>

          <th class="text-left" style="">
            <img
              v-if="this.columnName != 'contract_weekwise_name'"
              @click="onSortValue('contract_weekwise_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('contract_weekwise_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('contract_weekwise_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("contract", 2) }} {{ $t("weekwise") }} {{ $tc("name", 2) }}
          </th>
          <!-- <th>{{ $tc('week',2) }}</th> -->
        </tr>
      </thead>
      <tbody v-if="contracts_by_weekwise.length > 0">
        <tr
          v-for="(contract, contractKey) in contracts_by_weekwise"
          :key="contractKey"
          class="light_grey_back"
        >
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  contract.contracts_by_weekwise_is_active == 'Y'
                    ? 'active'
                    : 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-2">
                <b-dropdown-item
                  v-if="$can('update', 'Weekwise Contract')"
                  @click="
                    goToRoute('/distributor/edit-weekwise-contract', contract)
                  "
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute('/distributor/view-weekwise-contract', contract)
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  contract.contracts_by_weekwise_is_active == 'Y'
                    ? 'active'
                    : 'inactive'
                "
              />

              <i
                v-if="$can('update', 'Weekwise Contract')"
                class="edit-pen icon blue-icon cursor-pointer ml-2"
                @click.prevent.stop="
                  goToRoute('/distributor/edit-weekwise-contract', contract)
                "
                v-b-tooltip="'Edit'"
                tabindex="0"
              ></i>

              <i
                class="icon-eye blue-icon cursor-pointer ml-2"
                @click.prevent.stop="
                  goToRoute('/distributor/view-weekwise-contract', contract)
                "
                v-b-tooltip="'View'"
                tabindex="0"
              ></i>
            </div>
          </td>

          <td style="padding-left: 20px">
            {{ contract.contract_weekwise_name }}
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="2">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import { BASEURL } from "@/config/index.js";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 20,
      currentPage: 1,
      rows: 0,
      selectedvalue: "20",
      gridView: false,
      listView: true,
      contracts_by_weekwise: [],
      viewingnumbers: [],
      URL_BASE: BASEURL,

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getviewingnumber();
  },
  mounted() {
    this.getContractsList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getContractsList();
      } else {
        this.currentPage = event;
        this.getContractsList();
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getContractsList();
    },
    getContractsList: function () {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      DistributorService.GetAllWeekWiseContractList(payload)
        .then((response) => {
          const { data } = response;
          this.rows = data.totalRows || 0;
          if (data && data.status && data.Records.length > 0) {
            this.contracts_by_weekwise = data.Records;
            if (data.totalRows < 10) {
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    goToRoute: function (path, { cbw_common_code }) {
      this.$router.push({
        path: path,
        query: {
          cbw_common_code: cbw_common_code,
        },
      });
    },
    /* eslint-disable */

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/WeekWiseContractComponents/weekwiseContract.vue